import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// 具体上报方法的实现
import throttle from 'lodash-es/throttle';
import { getPath, getUuid, helper, isAndroid, isAppx, isIos, ownAddEventListener, storage } from "../utils";
import Base64 from "../utils/Base64";
import { _sendBatch } from "../utils/sendBatch";
var doc = isAppx ? document : null;
var dataCache = [];
var logTask = 0;
var Tracert = /*#__PURE__*/function () {
  function Tracert() {
    var _window,
      _window$navigator,
      _window2,
      _this2 = this;
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Tracert);
    // 业务类型
    _defineProperty(this, "bizType", '');
    // 终端id
    _defineProperty(this, "deviceId", '');
    // 日志等级
    _defineProperty(this, "logLevel", '2');
    // 日志版本
    _defineProperty(this, "logVersion", '3');
    // 用户id
    _defineProperty(this, "userId", '');
    // spm的a位
    _defineProperty(this, "spmAPos", '');
    // spm的b位
    _defineProperty(this, "spmBPos", '');
    // pageId
    _defineProperty(this, "pageId", '');
    // server
    _defineProperty(this, "server", '');
    // debug模式
    _defineProperty(this, "debug", false);
    // 渠道
    _defineProperty(this, "chInfo", '');
    // 投放信息
    _defineProperty(this, "scm", '');
    // 环境
    _defineProperty(this, "env", 'prod');
    // referSpm
    _defineProperty(this, "referSPM", '');
    // referUrl
    _defineProperty(this, "refUrl", '');
    // 点击埋点事件触发的事件类型，默认是click
    _defineProperty(this, "eventType", 'click');
    // session id
    _defineProperty(this, "sessionId", '');
    // 元数据通用参数, 该参数的所有数据均会在每次发送埋点带上
    _defineProperty(this, "mdata", {});
    // 系统信息
    _defineProperty(this, "systemInfo", {});
    // 网络类型
    _defineProperty(this, "networkType", '');
    // path
    _defineProperty(this, "url", '');
    // 应用id，建议使用productId代替
    _defineProperty(this, "appId", '');
    // 产品 id，标识一个业务，组装客户端id，为了兼容老版本，没有传时使用appId代替
    _defineProperty(this, "productId", '');
    // 安装包版本号，当前小程序应用或者H5离线包应用，为了统计代码覆盖率和出错版本
    _defineProperty(this, "packageVersion", '');
    // 插件加载是否完成
    _defineProperty(this, "pluginReady", true);
    // 加载的插件
    _defineProperty(this, "_plugins", []);
    // 插件加载完成回调标识数
    _defineProperty(this, "_pluginLoadCnt", 0);
    // 缓存的事件(之前)
    _defineProperty(this, "_beforeEvObj", void 0);
    // 缓存的事件(之后)
    _defineProperty(this, "_afterEvObj", void 0);
    // 埋点依赖是否加载完成
    _defineProperty(this, "ready", true);
    // 未准备好时候的缓存数组
    _defineProperty(this, "apiCashList", []);
    // 缓存副作用清除方法
    _defineProperty(this, "_sideEffects", []);
    // 开关，false 关闭所有上报
    _defineProperty(this, "switch", true);
    // 自动曝光
    _defineProperty(this, "autoExpo", false);
    // 每个dom只曝光一次
    _defineProperty(this, "expoOnce", false);
    // 曝光缓存
    _defineProperty(this, "expoObj", {});
    // 日志合并开关
    _defineProperty(this, "contact", false);
    // 批量发送频率，默认一秒一次
    _defineProperty(this, "sendFrequency", 1000);
    // 一次发送的日志条数
    _defineProperty(this, "batchCount", 5);
    // UA
    _defineProperty(this, "userAgent", (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent);
    // 微应用场景
    _defineProperty(this, "container", (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.document);
    // platform
    _defineProperty(this, "platform", '');
    // expo的回调方法; 给个function出来, 方便覆盖;
    _defineProperty(this, "expoType", function (callback) {
      if (isAppx) return;
      return ownAddEventListener('scroll', doc, throttle(callback, 300, {
        leading: false,
        trailing: true
      }));
    });
    _defineProperty(this, "_isMain", void 0);
    _defineProperty(this, "_instanceId", void 0);
    this.systemInfo = {
      model: '',
      pixelRatio: 0,
      // 设备像素比
      windowWidth: 0,
      windowHeight: 0,
      language: '',
      version: '',
      platform: '',
      system: '',
      screenWidth: 0,
      screenHeight: 0,
      brand: '',
      app: ''
    };
    this._beforeEvObj = {
      logPv: [],
      click: [],
      expo: [],
      set: [],
      send: [],
      log: []
    };
    this._afterEvObj = {
      logPv: [],
      click: [],
      expo: [],
      send: [],
      log: []
    };
    Object.assign(this, opt);

    // 关闭上报钩子
    this.before('send', function () {
      return _this2.switch;
    });
    this.init(opt);
  }
  _createClass(Tracert, [{
    key: "init",
    value: function init(opt) {
      this.set({
        autoExpo: opt.autoExpo
      });
      // 终端id
      if (!this.deviceId) {
        this._setDeviceUUid();
      }

      // sessionId，初始化时设置一次
      this.sessionId = this.sessionId ? this.sessionId : getUuid();
      if (this.ready) {
        this._sendSuccessRate();
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var _this = this;
      return _this[key];
    }

    /**
     * 为指定的事件，绑定优先执行方法
     * @param {String} fnName 方法名称
     * @param {Function} fn 方法
     */
  }, {
    key: "before",
    value: function before(fnName, fn) {
      var beforEventObj = this._beforeEvObj;
      // 不是目前方法，或者回调方法不存在
      if (!beforEventObj[fnName]) {
        console.error('目标方法不支持该事件');
        return;
      }
      if (typeof fn !== 'function') {
        console.error('监听器不是函数');
        return;
      }
      // 置入缓存
      beforEventObj[fnName].push(fn);
    }

    // 执行优先执行方法
  }, {
    key: "_runBeforeFns",
    value: function _runBeforeFns(fn, args) {
      var beforEventObj = this._beforeEvObj[fn] || [];
      // 不存在绑定的事件
      if (!(beforEventObj !== null && beforEventObj !== void 0 && beforEventObj.length)) {
        return true;
      }

      // 依次执行方法
      for (var i = 0; i < beforEventObj.length; i++) {
        var res = beforEventObj[i].call(this, args);
        if (res === false) {
          console.debug("Tracert before fns: ".concat(fn, " stop propagation"));
          return false;
        }
      }
      return true;
    }

    /**
     * 为指定的事件，绑定结束执行方法
     * @param {String} fnName 方法名称
     * @param {Function} fn 方法
     */
  }, {
    key: "after",
    value: function after(fnName, fn) {
      var afterEventObj = this._afterEvObj;
      // 不是目前方法，或者回调方法不存在
      if (!afterEventObj[fnName]) {
        console.error('目标方法不支持该事件');
        return;
      }
      if (typeof fn !== 'function') {
        console.error('监听器不是函数');
        return;
      }

      // 置入缓存
      afterEventObj[fnName].push(fn);
    }

    // 执行结束执行方法
  }, {
    key: "_runAfterFns",
    value: function _runAfterFns(fn, args) {
      var afterEventObj = this._afterEvObj[fn] || [];
      // 不存在绑定的事件
      if (!(afterEventObj !== null && afterEventObj !== void 0 && afterEventObj.length)) {
        return;
      }
      // 依次执行方法
      for (var i = 0; i < afterEventObj.length; i++) {
        afterEventObj[i].call(this, args);
      }
    }

    /**
     * 批量载入插件
     * @param {Array} ps 插件列表
     */
  }, {
    key: "loadPlugins",
    value: function loadPlugins(ps) {
      if (!(ps !== null && ps !== void 0 && ps.length)) {
        return;
      }
      this._plugins = ps;
      for (var i = 0; i < ps.length; i++) {
        var plugin = ps[i];
        this.loadPlugin(plugin);
      }
    }

    /**
     * 载入插件
     * @param {Function|String} p 插件方法或名称
     */
  }, {
    key: "loadPlugin",
    value: function loadPlugin(p) {
      var _this3 = this;
      if (typeof p !== 'function') {
        return;
      }
      var fn = p;
      fn(this, function () {
        _this3._pluginLoadCnt++;
        if (_this3._pluginLoadCnt !== _this3._plugins.length) {
          return;
        }
        _this3.set({
          pluginReady: true
        });
        // 抛出事件
        var event = document.createEvent('HTMLEvents');
        event._isMain = !!_this3._isMain;
        event._instanceId = _this3._instanceId;
        event.initEvent('TracertPluginReady', true, true);
        _this3.container.dispatchEvent(event);
      });
    }

    /**
     * 缓存清除副作用的方法
     */
  }, {
    key: "addSideEffects",
    value: function addSideEffects() {
      // eslint-disable-next-line prefer-rest-params
      var args = [].slice.call(arguments);
      if (typeof args[0] === 'function') {
        if (this._sideEffects.indexOf(args) === -1) {
          this._sideEffects.push(args);
        }
      }
    }

    /**
     * 清除副作用
     */
  }, {
    key: "clearSideEffects",
    value: function clearSideEffects() {
      // 不存在
      if (!this._sideEffects || !this._sideEffects.length) {
        return true;
      }
      // 依次执行方法
      for (var i = 0; i < this._sideEffects.length; i++) {
        var args = this._sideEffects[i];
        var options = args.slice(1);
        if (typeof args[0] === 'function') {
          args[0].apply(this, options);
        }
      }
      this._sideEffects.length = 0;
      return true;
    }

    /**
     * 配置Tracert的属性或者方法
     * @param {Object} options
     */
  }, {
    key: "set",
    value: function set() {
      var _this$_runBeforeFns;
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = opt;
      var res = this === null || this === void 0 ? void 0 : (_this$_runBeforeFns = this._runBeforeFns) === null || _this$_runBeforeFns === void 0 ? void 0 : _this$_runBeforeFns.call(this, 'set', options);
      if (!res) {
        return;
      }
      // mdata 为特殊参数 只做合并不做替换
      if (_typeof(options.mdata) === 'object') {
        options.mdata = _objectSpread(_objectSpread({}, this.mdata), options.mdata);
      }
      Object.assign(this, options);
      // 依赖已经准备好
      if (options.ready === true && this.pluginReady || options.pluginReady === true && this.ready) {
        // 上报成功率数据
        this._sendSuccessRate();

        // 执行缓存
        for (var i = 0; i < this.apiCashList.length; i++) {
          var args = this.apiCashList[i];
          this.call.apply(this, _toConsumableArray(args));
        }

        // 清空
        this.apiCashList = [];
      }
    }

    /**
     * 通用唤起方法, 可以唤起Tracert所有方法，用于管理声明周期
     */
  }, {
    key: "call",
    value: function call() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      // const args = [].slice.call(arguments);
      var methodName = args[0];
      var func = this[methodName];
      if (!func || typeof func !== 'function') {
        console.warn("\u672A\u627E\u5230\u65B9\u6CD5\uFF1A".concat(methodName));
        return;
      }
      var result;
      if (this.ready && this.pluginReady) {
        var options = args.slice(1);
        // options = this.optionsHandle(options);
        result = func.apply(this, options);
      } else {
        // 页面没加载完成，缓存
        this.apiCashList.push(args);
      }
      return result;
    }

    /**
     * pv上报
     * @param opt 扩展参数
     */
  }, {
    key: "logPv",
    value: function logPv() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var res = this._runBeforeFns('logPv', opt);
      if (!res) {
        return;
      }
      var pageSpm = this.spmAPos && this.spmBPos ? [this.spmAPos, this.spmBPos].join('.') : '';
      this._setPageId(pageSpm);
      this._initRefer(pageSpm);
      var params = {
        actionId: 'pageMonitor',
        spmId: pageSpm,
        param1: '',
        param2: '',
        param3: '',
        param4: _objectSpread(_objectSpread({}, this.mdata), opt)
      };
      this.call('reportBehaviorDataimmediate', params);
      this._runAfterFns('logPv', opt);
    }

    /**
     * 点击埋点发送方法
     * @param {String} spmId spmId
     * @param {Object} extra 额外的参数（扩展4）
     * @param {Object} options 额外的参数，供插件修改属性使用（含扩展5）
     */
  }, {
    key: "click",
    value: function click() {
      var spmId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var res = this._runBeforeFns('click', extra);
      if (!res) {
        return;
      }
      var params = {
        param1: '',
        param2: '',
        param3: '',
        param4: _objectSpread(_objectSpread({}, this.mdata), extra),
        actionId: 'clicked',
        spmId: this._fillspm(spmId)
      };
      if (extra !== null && extra !== void 0 && extra.immediate) {
        this.call('reportBehaviorDataimmediate', params);
      } else {
        this.call('remoteLog', params);
      }
      this._runAfterFns('click', params);
    }

    /**
     * 曝光埋点发送方法
     * @param {String} spmId spmId
     * @param {String} offset 当前曝光埋点滚动的方向
     * @param {Object} extra 额外的参数（扩展4）
     * @param {Object} options 系统参数（扩展5）
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "expo",
    value: function expo() {
      var spmId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var res = this._runBeforeFns('expo', extra);
      if (!res) {
        return;
      }
      var params = {
        param1: '',
        param2: '',
        param3: '',
        param4: _objectSpread(_objectSpread({}, this.mdata), extra),
        actionId: 'exposure',
        spmId: this._fillspm(spmId)
      };
      if (this.expoOnce) {
        this.expoObj = this.expoObj || {};
        var curExpoInfo = this.expoObj[params.spmId] || {};
        if (!this.expoObj[params.spmId]) {
          this.expoObj[params.spmId] = curExpoInfo;
        }
        var uuid = params.spmId;
        // 已经曝光
        if (curExpoInfo[uuid] === 1) {
          return;
        } else {
          curExpoInfo[uuid] = 1; // 只曝光一次 加入缓存; 1标识有效曝光
        }
      }

      if (extra !== null && extra !== void 0 && extra.immediate) {
        this.call('reportBehaviorDataimmediate', params);
      } else {
        this.call('remoteLog', params);
      }
      this._runAfterFns('expo', params);
    }

    /**
     * 前端日志和性能日志上报
     * @param eventId 事件id
     * @param extra 扩展参数
     */
  }, {
    key: "log",
    value: function log() {
      var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'web_info';
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var res = this._runBeforeFns('log', extra);
      if (!res) {
        return;
      }
      var immediate = extra.immediate;
      var params = {
        eventId: eventId,
        param4: _objectSpread(_objectSpread({}, this.mdata), extra)
      };
      if (!isAppx) {
        helper.console.log('==web_info======', params);
        helper.console.log('==web_info======', immediate);
      }
      if (extra !== null && extra !== void 0 && extra.immediate) {
        this.call('reportDataimmediate', params);
      } else {
        this.call('reportData', params);
      }
      this._runAfterFns('log', params);
    }

    /**
     * 发送用户行为数据
     * @param options
     */
  }, {
    key: "remoteLog",
    value: function remoteLog(options) {
      // 组长D-VM日志
      options.param4 = _objectSpread(_objectSpread({}, options.param4), {}, {
        containerType: this._getContainerType(),
        logVersion: 1
      });
      var data = this.formatBehivorData(options);
      if (!isAppx) {
        helper.report(data.join(), 'spm');
      }
      this._send(data);
    }

    /**
     * 发送日志和性能数据
     * @param options
     */
  }, {
    key: "reportData",
    value: function reportData(options) {
      options.param4 = _objectSpread(_objectSpread({}, options.param4), {}, {
        containerType: this._getContainerType(),
        logVersion: 1
      });
      var data = this.formatEventData(options);
      if (!isAppx) {
        helper.report(data.join(), 'report');
      }
      this._send(data);
    }

    /**
     * 事件日志单独上报
     * @params options
     */
  }, {
    key: "reportDataimmediate",
    value: function reportDataimmediate(options) {
      options.param4 = _objectSpread(_objectSpread({}, options.param4), {}, {
        containerType: this._getContainerType(),
        logVersion: 1
      });
      var data = this.formatEventData(options);
      if (!isAppx) {
        helper.report(data.join(), 'immediate');
      }
      _sendBatch({
        datas: [data],
        dataCache: dataCache,
        server: this.server,
        platform: this.platform
      });
    }

    /**
     * 行为日志单独上报
     * @param options
     */
  }, {
    key: "reportBehaviorDataimmediate",
    value: function reportBehaviorDataimmediate(options) {
      options.param4 = _objectSpread(_objectSpread({}, options.param4), {}, {
        containerType: this._getContainerType(),
        logVersion: 1
      });
      var data = this.formatBehivorData(options);
      if (!isAppx) {
        helper.report(data.join(), 'immediate');
      }
      _sendBatch({
        datas: [data],
        dataCache: dataCache,
        server: this.server,
        platform: this.platform
      });
    }

    /**
     * 组装行为上报数据
     * @param options
     */
  }, {
    key: "formatBehivorData",
    value: function formatBehivorData(options) {
      var _this$systemInfo, _this$systemInfo2, _this$systemInfo3, _this$systemInfo4, _this$systemInfo5, _this$systemInfo6, _this$systemInfo7, _this$systemInfo8, _this$systemInfo9, _this$systemInfo10;
      var actionId = options.actionId,
        spmId = options.spmId,
        param1 = options.param1,
        param2 = options.param2,
        param3 = options.param3,
        param4 = options.param4,
        param5 = options.param5,
        stayTime = options.stayTime;
      var dt = new Date();
      var fillDate = function fillDate(num) {
        return num < 10 ? "0".concat(num) : "".concat(num);
      };
      var param5ExtraData = {
        reporterJsVersion: "@alipay/intl-tracker-0.0.9001657688-dev.1",
        userAagent: this.userAgent,
        URL: this.url || getPath(),
        logId: getUuid()
      };
      // 设备信息 字段44
      var deviceInfo = {
        brand: ((_this$systemInfo = this.systemInfo) === null || _this$systemInfo === void 0 ? void 0 : _this$systemInfo.brand) || '',
        windowWidth: ((_this$systemInfo2 = this.systemInfo) === null || _this$systemInfo2 === void 0 ? void 0 : _this$systemInfo2.windowWidth) || '',
        windowHeight: ((_this$systemInfo3 = this.systemInfo) === null || _this$systemInfo3 === void 0 ? void 0 : _this$systemInfo3.windowHeight) || '',
        screenWidth: ((_this$systemInfo4 = this.systemInfo) === null || _this$systemInfo4 === void 0 ? void 0 : _this$systemInfo4.screenWidth) || '',
        screenHeight: ((_this$systemInfo5 = this.systemInfo) === null || _this$systemInfo5 === void 0 ? void 0 : _this$systemInfo5.screenHeight) || ''
      };
      var reportTime = "".concat(dt.getFullYear(), "-").concat(fillDate(dt.getMonth() + 1), "-").concat(fillDate(dt.getDate()), " ").concat(fillDate(dt.getHours()), ":").concat(fillDate(dt.getMinutes()), ":").concat(fillDate(dt.getSeconds()), ".").concat(dt.getMilliseconds());
      var arr = ['D-VM',
      // 1. 日志头 uniform_behavior
      reportTime,
      // 2. 客户端日志时间
      this._getClientId(),
      // 3. 客户端id
      this.systemInfo.version,
      // 4. 客户端版本
      this.logVersion,
      // 5.日志版本号
      this.deviceId,
      // 6. 终端id
      this.sessionId,
      // 7. 会话id
      this.userId || '-',
      // 8. userid
      actionId,
      // 9. 行为id
      '-',
      // 10. ABTest实验ID
      this.referSPM || '-',
      // 11. 上一页面spm + 上一页面 pageId
      '-',
      // 12. 子应用ID
      '-',
      // 13. 子应用版本
      this.refUrl,
      // 14. referUrl
      '-',
      // 15. 数据回流唯一ID
      spmId,
      // 16. spmId
      this.logLevel,
      // 17. 日志等级
      this.bizType,
      // 18. 业务类型 bizType
      'c',
      // 19. 日志类型
      param1 || '-',
      // 20. ext_info1
      param2 || '-',
      // 21. ext_info2
      param3 || '-',
      // 22. ext_info3
      param4 ? this._objToStr(param4) : '-',
      // 23. ext_info4
      this.chInfo || '-',
      // 24. sourceId营销来源
      stayTime || '-',
      // 25. 自动埋点页面停留时长
      '-',
      // 26. utdid
      '-',
      // 27. ucid用例编号
      this.pageId,
      // 28. pageId
      '-',
      // 29. 上一个VIEWID
      this.url || '',
      // 30. 当前URl
      '-',
      // 31. 当前ACTIONID
      '-',
      // 32. 当前ACTIONTOKEN
      '1000',
      // 33. 抽样率
      ((_this$systemInfo6 = this.systemInfo) === null || _this$systemInfo6 === void 0 ? void 0 : _this$systemInfo6.brand) || '-',
      // 34. 手机型号 , 手机型号获取不到, 降级为品牌
      ((_this$systemInfo7 = this.systemInfo) === null || _this$systemInfo7 === void 0 ? void 0 : _this$systemInfo7.system) || '-',
      // 35. 操作系统版本
      this.networkType || '-',
      // 36. 网络类型
      this.packageVersion || '-',
      // 37. 内部版本号
      '-',
      // 38. 渠道号
      ((_this$systemInfo8 = this.systemInfo) === null || _this$systemInfo8 === void 0 ? void 0 : _this$systemInfo8.language) || '-',
      // 39. 语言
      '-',
      // 40. hotPatch版本号
      '-',
      // 41. Android: CPU CoreNum
      '-',
      // 42. Android: CPU MaxFreq，单位MHz
      '-',
      // 43. Android: TotalMem，单位MB
      this._objToStr(deviceInfo),
      // 44. 业务额外参数两平台保持一致
      '-',
      // 45. 标识 pageEnd 时判定first在不在历史页面列表中，不在就是脏数据，该标志=0，在的话就是1
      "".concat((_this$systemInfo9 = this.systemInfo) === null || _this$systemInfo9 === void 0 ? void 0 : _this$systemInfo9.screenWidth, "x").concat((_this$systemInfo10 = this.systemInfo) === null || _this$systemInfo10 === void 0 ? void 0 : _this$systemInfo10.screenHeight) || '-',
      // 46. 分辨率
      '-',
      // 47. 进程名
      getUuid(),
      // 48. 序列id
      '-',
      // 49. 原生设备ID
      param5 ? this._objToStr(Object.assign({}, param5ExtraData, param5)) : this._objToStr(param5ExtraData) // 50. 扩展字段5 存放埋点规范相关的字段，目前包括： isTinyTracker 是否是小程序框架埋点. newChinfo 流量位. scm 内容
      ];

      return arr.map(function (item) {
        return new String(item).replace(/,/gi, '_').toString();
      });
    }

    /**
     * 组装事件上报日志
     * @param options
     */
  }, {
    key: "formatEventData",
    value: function formatEventData(options) {
      var _this$systemInfo11, _this$userId, _this$systemInfo12, _this$systemInfo12$pl, _this$systemInfo13, _this$systemInfo13$sy, _this$systemInfo14, _this$systemInfo14$mo, _this$packageVersion, _this$systemInfo15, _this$systemInfo15$la, _this$systemInfo16, _this$systemInfo17, _this$systemInfo18, _this$systemInfo18$br;
      var eventId = options.eventId,
        param4 = options.param4;
      var dt = new Date();
      var fillDate = function fillDate(num) {
        return num < 10 ? "0".concat(num) : "".concat(num);
      };
      var reportTime = "".concat(dt.getFullYear(), "-").concat(fillDate(dt.getMonth() + 1), "-").concat(fillDate(dt.getDate()), " ").concat(fillDate(dt.getHours()), ":").concat(fillDate(dt.getMinutes()), ":").concat(fillDate(dt.getSeconds()), ":").concat(dt.getMilliseconds());
      var arr = ['D-AE',
      // 1. 日志头
      reportTime,
      // 2. 客户端日志时间
      this._getClientId() || '-',
      // 3. 客户端ID
      ((_this$systemInfo11 = this.systemInfo) === null || _this$systemInfo11 === void 0 ? void 0 : _this$systemInfo11.version) || '-',
      // 4. 客户端版本
      this.logVersion || '-',
      // 5. 日志版本
      this.deviceId || '-',
      // 6. 终端ID
      this.sessionId || '-',
      // 7. 会话ID
      ((_this$userId = this.userId) === null || _this$userId === void 0 ? void 0 : _this$userId.replace(/,/g, '%2C')) || '-',
      // 8. 用户ID
      1000,
      // 9. 采样率
      eventId || '-',
      // 10. 事件ID
      this.bizType || '-',
      // 11. bizType
      this.logLevel || '-',
      // 12. logLevel默认值
      this.pageId || '-',
      // 13. pageId
      '-',
      // 14. abtestId
      '-',
      // 15. ucid用例编号
      '-',
      // 16. 补丁版本
      ((_this$systemInfo12 = this.systemInfo) === null || _this$systemInfo12 === void 0 ? void 0 : (_this$systemInfo12$pl = _this$systemInfo12.platform) === null || _this$systemInfo12$pl === void 0 ? void 0 : _this$systemInfo12$pl.replace(/,/g, '%2C')) || '-',
      // 17. 操作系统类别
      ((_this$systemInfo13 = this.systemInfo) === null || _this$systemInfo13 === void 0 ? void 0 : (_this$systemInfo13$sy = _this$systemInfo13.system) === null || _this$systemInfo13$sy === void 0 ? void 0 : _this$systemInfo13$sy.replace(/,/g, '%2C')) || '-',
      // 18. 操作系统版本 淘宝 iphone下会带,  【iphone11,6】
      this.networkType || '-',
      // 19. 网络类型
      ((_this$systemInfo14 = this.systemInfo) === null || _this$systemInfo14 === void 0 ? void 0 : (_this$systemInfo14$mo = _this$systemInfo14.model) === null || _this$systemInfo14$mo === void 0 ? void 0 : _this$systemInfo14$mo.replace(/,/g, '%2C')) || '-',
      // 20. 手机型号
      ((_this$packageVersion = this.packageVersion) === null || _this$packageVersion === void 0 ? void 0 : _this$packageVersion.replace(/,/g, '%2C')) || '-',
      // 21. 内部版本号
      '-',
      // 22. 渠道号
      '-',
      // 23. UTDID
      ((_this$systemInfo15 = this.systemInfo) === null || _this$systemInfo15 === void 0 ? void 0 : (_this$systemInfo15$la = _this$systemInfo15.language) === null || _this$systemInfo15$la === void 0 ? void 0 : _this$systemInfo15$la.replace(/,/g, '%2C')) || '-',
      // 24. 语言
      '-',
      // 25. 制造商
      "".concat((_this$systemInfo16 = this.systemInfo) === null || _this$systemInfo16 === void 0 ? void 0 : _this$systemInfo16.screenWidth, "x").concat((_this$systemInfo17 = this.systemInfo) === null || _this$systemInfo17 === void 0 ? void 0 : _this$systemInfo17.screenHeight) || '-',
      // 26. 分辨率
      this.appId || '-',
      // 27. appId
      '-',
      // 28. 进程名
      ((_this$systemInfo18 = this.systemInfo) === null || _this$systemInfo18 === void 0 ? void 0 : (_this$systemInfo18$br = _this$systemInfo18.brand) === null || _this$systemInfo18$br === void 0 ? void 0 : _this$systemInfo18$br.replace(/,/g, '%2C')) || '-',
      // 29. 手机属性
      '-',
      // 30. 客户端预留信息
      '-',
      // 31. 用户信息预留
      getUuid() || '-',
      // 32. 序列id
      '-',
      // 33. 业务额外参数，两平台保持一致
      '-',
      // 34. 扩展1
      '-',
      // 35. 扩展2
      '-',
      // 36. 扩展3
      this._objToStr(Object.assign({}, {
        reporterJsVersion: "@alipay/intl-tracker-0.0.9001657688-dev.1",
        userAagent: this.userAgent,
        URL: this.url || getPath(),
        logId: getUuid()
      }, param4)),
      // 37. 扩展4
      '-',
      // 38 扩展字段5
      '-' // 39 预留字段2
      ];

      return arr.map(function (item) {
        return new String(item).replace(/,/gi, '_').toString();
      });
    }

    /**
     * 发送上报请求
     * @param data D-VM或者D-AE日志
     */
  }, {
    key: "_send",
    value: function _send(data) {
      var res = this._runBeforeFns('send', data);
      if (!res) {
        return;
      }
      if (this.debug) {
        console.log(data);
      }
      if (!this.server) {
        console.warn('请配置Tracert服务接收地址');
        return;
      }

      // 先缓存，分批发送
      dataCache.push(data);
      this._httpRequest();
      this._runAfterFns('send', data);
    }

    /**
     * 分批发送请求
     */
  }, {
    key: "_httpRequest",
    value: function _httpRequest() {
      var _this4 = this;
      if (logTask !== 0) return;
      // 先发送再等待
      _sendBatch({
        datas: dataCache.splice(0, this.batchCount),
        dataCache: dataCache,
        server: this.server,
        platform: this.platform
      });

      // 每次发送5个请求，间隔一秒
      logTask = setInterval(function () {
        var datas = dataCache.splice(0, _this4.batchCount);
        if (!datas.length) {
          clearInterval(logTask);
          logTask = 0;
          return true;
        }
        if (datas.length) {
          _sendBatch({
            datas: datas,
            dataCache: dataCache,
            server: _this4.server,
            platform: _this4.platform
          });
        }
        _this4._httpRequest();
      }, this.sendFrequency);
    }

    /**
     * 上报成功率
     */
  }, {
    key: "_sendSuccessRate",
    value: function () {
      var _sendSuccessRate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var rate, options, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return storage.getStorage('tracker-rate');
            case 2:
              rate = _context.sent;
              if (!rate) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return storage.removeStorage('tracker-rate');
            case 6:
              options = {
                eventId: 'web_info',
                param4: {
                  containerType: this._getContainerType(),
                  logVersion: 1,
                  idengine_tracker_rate: rate
                }
              };
              data = this.formatEventData(options);
              dataCache.unshift(data);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _sendSuccessRate() {
        return _sendSuccessRate2.apply(this, arguments);
      }
      return _sendSuccessRate;
    }() // 浏览器uuid
  }, {
    key: "_setDeviceUUid",
    value: function () {
      var _setDeviceUUid2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var key, uuid;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              key = 'deivceTag';
              _context2.next = 3;
              return storage.getStorage(key, '');
            case 3:
              uuid = _context2.sent;
              if (uuid) {
                _context2.next = 9;
                break;
              }
              uuid = "device_".concat(getUuid());
              this.set({
                deviceId: uuid
              });
              _context2.next = 9;
              return storage.setStorage(key, uuid);
            case 9:
              this.set({
                deviceId: uuid
              });
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _setDeviceUUid() {
        return _setDeviceUUid2.apply(this, arguments);
      }
      return _setDeviceUUid;
    }() // 初始化链路信息
  }, {
    key: "_initRefer",
    value: function () {
      var _initRefer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(spmId) {
        var key, referSPM;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              key = 'spm-refer';
              _context3.next = 3;
              return storage.getStorage(key, '');
            case 3:
              referSPM = _context3.sent;
              this.set({
                referSPM: referSPM
              });
              _context3.next = 7;
              return storage.setStorage(key, spmId + '|' + this.pageId);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _initRefer(_x) {
        return _initRefer2.apply(this, arguments);
      }
      return _initRefer;
    }() // 设置pageId
  }, {
    key: "_setPageId",
    value: function _setPageId(spmId) {
      this.set({
        pageId: this._getPageId(spmId)
      });
    }
  }, {
    key: "_getPageId",
    value: function _getPageId(spmId) {
      return "".concat(spmId, "_").concat(Base64.fromNumber(+new Date()));
    }

    // 补全spmId，比如 c.d 补全为a.b.c.d
  }, {
    key: "_fillspm",
    value: function _fillspm() {
      var spmId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var spmArr = spmId.split('.');
      if (spmArr.length > 2) {
        return spmId;
      }
      return "".concat(this.spmAPos, ".").concat(this.spmBPos, ".").concat(spmId);
    }

    // 客户端id productId_环境_平台
  }, {
    key: "_getClientId",
    value: function _getClientId() {
      var _this$systemInfo19, _this$systemInfo19$pl;
      return "".concat(this.productId || this.appId, "_").concat(((_this$systemInfo19 = this.systemInfo) === null || _this$systemInfo19 === void 0 ? void 0 : (_this$systemInfo19$pl = _this$systemInfo19.platform) === null || _this$systemInfo19$pl === void 0 ? void 0 : _this$systemInfo19$pl.toUpperCase()) || '', "-").concat(this.env.toUpperCase());
    }
  }, {
    key: "_getContainerType",
    value: function _getContainerType() {
      return isAppx ? 'MINIAPP' : isAndroid || isIos ? 'H5' : 'PC';
    }
  }, {
    key: "_objToStr",
    value: function _objToStr(obj) {
      var spliter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '^';
      if (!obj) return '';
      var strArr = [];
      var prop;
      if (obj instanceof Array) {
        strArr = obj;
      } else if (obj instanceof Object) {
        for (prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            strArr.push("".concat(prop, "=").concat(obj[prop]));
          }
        }
      }
      return strArr.join(spliter).replace(/,/g, '%2C');
    }
  }]);
  return Tracert;
}();
export default Tracert;